<div
  class="tw-flex tw-items-center tw-gap-6 tw-py-2 tw-w-full tw-cursor-pointer tw-px-2"
  (click)="toggleExpanded()"
>
  <!-- Dropdown Toggle Icon -->
  <div
    class="tw-flex tw-items-center tw-justify-center tw-w-8 tw-h-8 tw-rounded-lg tw-bg-dt-surface-elevated tw-shadow-icon"
  >
    <icon
      [name]="'right-arrow'"
      [size]="4"
      [currentColor]="'neutral-800'"
      [ngClass]="{ 'tw-rotate-90': isExpanded, 'tw-rotate-0': !isExpanded }"
    >
    </icon>
  </div>

  <!-- Group Key -->
  <div class="tw-flex tw-items-center tw-gap-4">
    <span class="tw-font-semibold tw-text-gray-900">{{ groupKey }}</span>

    <!-- Item Count Badge -->
    <span
      class="tw-inline-flex tw-items-center tw-justify-center tw-min-w-[24px] tw-h-6 tw-px-2 tw-rounded-lg tw-bg-blue-100 tw-text-blue-800 tw-text-xs tw-font-medium"
    >
      {{ itemCount }}
    </span>

    <!--    @todo: at the moment of writing this, all the versions are wrapped inside a single group, fix that and then enable this-->
    <!--    &lt;!&ndash; Release State Badges &ndash;&gt;-->
    <!--    @if (hasPublished) {-->
    <!--      <span-->
    <!--        class="tw-inline-flex tw-items-center tw-px-2 tw-h-6 tw-rounded-full tw-bg-green-100 tw-text-green-800 tw-text-xs tw-font-medium"-->
    <!--      >-->
    <!--        Published-->
    <!--      </span>-->
    <!--    }-->
    <!--    @if (hasDraft) {-->
    <!--      <span-->
    <!--        class="tw-inline-flex tw-items-center tw-px-2 tw-h-6 tw-rounded-full tw-bg-yellow-100 tw-text-yellow-800 tw-text-xs tw-font-medium"-->
    <!--      >-->
    <!--        Draft-->
    <!--      </span>-->
    <!--    }-->
  </div>
</div>
